/*
 * @Date: 2023-01-03 18:07:40
 * @LastEditTime: 2023-08-11 11:12:43
 * @Description: 
 */
import router from './router'
import { getToken } from '@/utils/auth' // 验权

router.beforeEach(async(to, from, next) => {
  const hasToken = getToken()
  // console.log(hasToken)
  if (getToken()) {
    if (to.path === '/') {
      next({ path: '/index/body1' })
    } else {
      next()
    }
  } else {
    if (['/login'].indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
    }
  }
  console.log('routerbeforeEach')
})
